<template>
  <LayoutDefault>
    <Container class="py-10">
      <h1 class="text-3xl lg:text-4xl font-bold text-brand-dark-blue mb-8">{{ t('guides.title') }}</h1>
      <div v-if="guides?.length" class="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <GuideCard v-for="guide in guides" :key="guide.id" :guide="guide" />
      </div>
    </Container>
  </LayoutDefault>
</template>

<script setup lang="ts">
const { t, locale } = useI18n()
const api = useApi()

const { data: guides } = await useAsyncData(
  () => `guides-list-${locale.value}`,
  () => api.getGuidesList(),
  { server: true, lazy: false, default: () => null, transform: res => res.data?.items ?? [], watch: [locale] }
)

const { data: pageData } = await useAsyncData(
  () => `guides-page-${locale.value}`,
  () => api.getPageByType('guides'),
  { default: () => null, transform: res => res.data, watch: [locale] }
)

useSeoMeta({
  title: pageData.value?.meta_title || t('guides.title'),
  description: pageData.value?.meta_description,
})
</script>
